import React, { useState } from "react";
import AddNewItem from "../../../../components/modals/AddNewItem";
import UserForm from "../components/UserForm";
import { DialogActions, Button, CircularProgress } from "@material-ui/core";
import ProfilesService from "../../../../../services/ProfilesService";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../redux/actions/ui";
import { makeStyles } from "@material-ui/core/styles";
import { useForm } from "react-hook-form";
import SaveIcon from "@material-ui/icons/Save";
import { capitalize } from "../../../../../utils/string";

const useStyles = makeStyles(theme => ({
  // DialogTitle
  DialogActions: {
    justifyContent: "center",
    "& .MuiButton-root": {
      // backgroundColor: 'red'
      minWidth: "12em",
      padding: "0.5em"
    }
  },  
}));

function AddNewUser(props) {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [isEditableForm, setIsEditableForm] = useState(true);
  const { isEditModal, data } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const { register, errors, handleSubmit, control, setError, setValue } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange",
    defaultValues: {
      phone: undefined,
      is_active: data !== undefined ? data.is_active : true,
    }
  });

  const performAction = async itemData => {    
    setIsLoadingSubmit(true);     
    setIsEditableForm(false);
    try{ 
      itemData.profile = itemData.profile_type  || props.profile;
      if(isEditModal){                    
        itemData.id = props.data.id;
        await ProfilesService.updateUser(itemData);
      }else{
        await ProfilesService.createUser(itemData);
      }             
      setIsLoadingSubmit(false);      
      setIsEditableForm(true);
      dispatch(showSnackBar("Successfully edited!"));      
      // We updated the list
      props.updateItemsList();
      props.onClose(false);      
    }catch (error) {
      console.log(error);
      let errorMsg = 'An error occurred!';
      let typeError = 'error';
      if(error && error.response && error.response.status === 409){
        errorMsg = 'User already exist with this profile';
        typeError = 'warning';
      }
      setIsLoadingSubmit(false);
      dispatch(showSnackBar(errorMsg, typeError));
      setIsEditableForm(true);
      const errorData = error.response ? error.response.data : {};
      if (typeof errorData == "object") {
        for (let [key, value] of Object.entries(errorData)) {
          setError(key, "notMatch", value);
        }             
      }      
    }  
  };

  const actions = (
    <DialogActions className={classes.DialogActions}>
      <Button onClick={() => props.onClose(false)} color="primary" variant="outlined" >
          Cancel
        </Button>
        <Button 
          type="submit"
          disabled={isLoadingSubmit}           
          onClick={handleSubmit(performAction)}
          color="primary" 
          autoFocus 
          variant="contained"
          startIcon={
            isLoadingSubmit ? <CircularProgress size={24}/> : <SaveIcon />
          }>
          Save
        </Button>
    </DialogActions>
  )

  return (
    <AddNewItem open={props.open} onClose={props.onClose} isLoading={isLoadingSubmit} actions={actions} 
    title={`${isEditModal ? 'Edit': 'Add new'} ${capitalize(props.profile) || 'User'}`}>
      <UserForm 
        isEditableForm={isEditableForm} 
        onSubmit={performAction} 
        formConfig={ {register, errors, handleSubmit, control, setValue} }
        data={isEditModal ? props.data : null}
        defaultProfile={props.profile}
      />
    </AddNewItem>
  )
}

export default AddNewUser;